export default __webpack_public_path__ + "static/media/avatar04.7d3bf8b3.svg";